var exports = {
  "kL": "x31de4314--0ae349--container",
  "wm": "x31de4314--0ae349--logo",
  "yr": "x31de4314--0ae349--logo-image",
  "Ky": "x31de4314--0ae349--block-wrapper",
  "iE": "x31de4314--0ae349--wrapper",
  "Qs": "x31de4314--0ae349--content",
  "Pf": "x31de4314--0ae349--label",
  "A4": "x31de4314--0ae349--control",
  "DD": "x31de4314--0ae349--title",
  "Qq": "x31de4314--0ae349--text",
  "N4": "x31de4314--0ae349--note",
  "Ht": "x31de4314--0ae349--mortgage-disclaimer",
  "CG": "x31de4314--0ae349--container--without-substrate",
  "h$": "x31de4314--0ae349--container--without-substratelogo",
};

module.exports = exports;
